import type { SignupOptions } from "@/lib/auth-api";

/** Флаги регистрации у демона: ещё читаются, прочитаны или прочитать не удалось. */
export type SignupOptionsState =
  | { status: "loading" }
  | { status: "ready"; options: SignupOptions }
  | { status: "unavailable" };

/** Что рисовать по адресу регистрации. */
export type SignupGate =
  | { kind: "checking" }
  | { kind: "form" }
  | { kind: "login"; notice: string | null };

/**
 * Решение по адресу `#/signup[/token]` из флагов демона (stage9-signup-invites,
 * Д2, Д9). По ссылке — форма при `signup-invite`; без ссылки — при
 * `signup-open`. Иначе форма входа с пояснением: регистрацию, которой нет,
 * не предлагаем (spec `web-signup`). Флаги не пересчитываются — только читаются.
 */
export function signupGate(options: SignupOptionsState, token: string | null): SignupGate {
  if (options.status === "loading") {
    return { kind: "checking" };
  }
  if (options.status === "unavailable") {
    return {
      kind: "login",
      notice: "Не удалось проверить, открыта ли регистрация. Попробуйте позже.",
    };
  }
  const { invite, open } = options.options;
  if (token !== null) {
    return invite
      ? { kind: "form" }
      : { kind: "login", notice: "Регистрация по приглашениям закрыта." };
  }
  if (open) {
    return { kind: "form" };
  }
  return {
    kind: "login",
    notice: invite ? "Для регистрации нужна ссылка-приглашение." : "Регистрация закрыта.",
  };
}
